import {fromJS} from 'immutable';
import {combineReducers} from 'redux-immutable';
import {reducer as form} from 'redux-form/immutable';
import {
    localization,
    bootstrap as bootstrapLocalization
} from '@epic-core/localization/dist/client/reducers/localization.reducer';
import user from './UserReducer';
import config from './ConfigReducer';
import asset from './AssetReducer';
import launcherIntegration from './LauncherIntegrationReducer';
import page from './PageReducer';
import shoppingCart from './ShoppingCartReducer';
import error from './ErrorReducer';
import review from './ReviewReducer';
import reviewDialog from './ReviewDialogReducer';
import upload from './UploadReducer';

const reducers = {
    form,
    localization,
    user,
    config,
    asset,
    launcherIntegration,
    page,
    shoppingCart,
    error,
    review,
    reviewDialog,
    upload
};
const bootstrapReducers = [bootstrapLocalization];

export function bootstrap(dataPreload) {
    let bootstrapState = fromJS({});
    for (const bootstrapReducer of bootstrapReducers) {
        bootstrapState = bootstrapState.merge(bootstrapReducer(dataPreload));
    }
    bootstrapState = bootstrapState.merge({
        config: dataPreload.config,
        user: dataPreload.user,
        shoppingCart: dataPreload.shoppingCart
    });
    return bootstrapState;
}

export function createReducer(extraReducers) {
    return combineReducers({
        ...reducers,
        ...extraReducers
    });
}
